import { connect } from "react-redux";

import makeMainView from "../components/make_main_view";

const mapStateToProps = (state) => {
  const focusView = state.navigation.focusView;
  const isLoading = state.loading.showLoadingOverlay;

  return { focusView, isLoading };
};

const mapDispatchToProps = () => ({
});

export default (mainComponents, FOCUS_VIEW_TYPES, showComponentWhenLoading = {}) => {
  return connect(mapStateToProps, mapDispatchToProps)(makeMainView(mainComponents, FOCUS_VIEW_TYPES, showComponentWhenLoading));
};

